export default {"src":"/_next/static/media/wealth-icon.84ac1342.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};